import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from './Icons';
export function ForWho() {
  const yesItems = ['El dinero te entra pero no te dura', 'Sientes ansiedad con tus finanzas', 'Sabes que podrías estar mejor… pero no avanzas', 'Has probado cosas y sigues igual', 'Sientes que hay algo interno que siempre te hace volver al mismo punto'];
  const noItems = ['No quieres hacer nada diferente', 'Buscas resultados sin aplicar nada', 'No puedes dedicar 10 minutos al día'];
  return <section className="bg-secondary py-10 md:py-16 px-4 md:px-12" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-78">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-card border-t-4 border-gold rounded-b-xl p-6 md:p-8 shadow-lg text-center" data-id="element-79">
            <h3 className="font-inter font-bold text-gold text-lg md:text-xl tracking-wider mb-6 md:mb-8 flex items-center justify-center gap-2" data-id="element-80">
              <CheckIcon className="w-6 h-6" data-id="element-81" /> SÍ ES PARA TI SI:
            </h3>
            <ul className="space-y-5 md:space-y-6" data-id="element-82">
              {yesItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 md:gap-4 text-left" data-id="element-83">
                  <CheckIcon className="w-5 h-5 md:w-6 md:h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-84" />
                  <span className="font-inter text-sm md:text-base text-warm-white leading-relaxed" data-id="element-85">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-primary border-t-4 border-warm-disabled rounded-b-xl p-6 md:p-8 shadow-lg text-center" data-id="element-86">
            <h3 className="font-inter font-bold text-warm-disabled text-lg md:text-xl tracking-wider mb-6 md:mb-8 flex items-center justify-center gap-2" data-id="element-87">
              <XIcon className="w-6 h-6" data-id="element-88" /> NO ES PARA TI SI:
            </h3>
            <ul className="space-y-5 md:space-y-6" data-id="element-89">
              {noItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 md:gap-4 text-left" data-id="element-90">
                  <XIcon className="w-5 h-5 md:w-6 md:h-6 text-warm-disabled flex-shrink-0 mt-0.5" data-id="element-91" />
                  <span className="font-inter text-sm md:text-base text-warm-muted leading-relaxed" data-id="element-92">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}